export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Controlla indirizzo"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inserisci indirizzo"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seleziona blockchain"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Esegui controllo"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rischio basso"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rischio medio"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rischio alto"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Non nella lista nera"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Controlla altro indirizzo"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scarica PDF"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Indietro"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seleziona fornitore"])}
}